import { z } from "zod"
import { CreateGroupDtoSchema } from "@mimber/schema"

/**
 * Form schema that uses the CreateGroupDto from @mimber/schema
 * Additional validation for form-specific requirements
 */
export const createGroupSchema = CreateGroupDtoSchema.extend({
  name: z
    .string()
    .min(1, "Group name is required")
    .max(255, "Group name must be less than 255 characters"),
  description: z
    .string()
    .max(1000, "Description must be less than 1000 characters")
    .optional()
    .or(z.literal(""))
    .transform((val) => (val === "" ? undefined : val)),
})

/**
 * Output type after transformation - this is what gets passed to onSubmit
 */
export type CreateGroupData = z.output<typeof createGroupSchema>
